import React, {useEffect, useImperativeHandle, useRef, forwardRef, useState} from "react";
import {Col, Form, InputGroup, Row} from "react-bootstrap";
import {
  amountFormatter,
  checkKey,
  nvl,
  parseNumber,
  toNull,
  onFocusText,
  onKeyDownNext,
  moveCellByArrow,
  sleepByPromise,
  onKeyDownShortCut,
  rpad, lpad,
  toSingleByte,
  calcLineWithholdTaxAmount
} from "../CMUtil";
import {getAPI} from "../APIUtil";
import AsyncSelect from "react-select/async";

export const RoyDtlLine = React.forwardRef((props, ref) => {

  const [index, setIndex] = useState("");
  const [royDtlId, setRoyDtlId] = useState("");
  const [royId, setRoyId] = useState("");
  const [lineNo, setLineNo] = useState(0);
  const [accSelected, setAccSelected] = useState(null);
  const [accCd, setAccCd] = useState("");
  const [authorCdSelected, setAuthorCdSelected] = useState(null);
  const [authorCd, setAuthorCd] = useState("");
  const [payTypeCdSelected, setPayTypeCdSelected] = useState(null);
  const [payTypeCd, setPayTypeCd] = useState("");
  const [bankCd, setBankCd] = useState("");
  const [bankBranchCd, setBankBranchCd] = useState("");
  const [kindOfAccountCl, setKindOfAccountCl] = useState("");
  const [bankAccountNo, setBankAccountNo] = useState("");
  const [bankAccountNm, setBankAccountNm] = useState("");
  const [bankAccount, setBankAccount] = useState("");
  const [linePayRate, setLinePayRate] = useState(0);
  const [lineAmount, setLineAmount] = useState(0);
  const [lineAmountEx1, setLineAmountEx1] = useState(0);
  const [lineAmountEx2, setLineAmountEx2] = useState(0);
  const [lineTaxRate, setLineTaxRate] = useState(0);
  const [lineTaxAmount, setLineTaxAmount] = useState(0);
  const [lineTotalAmount, setLineTotalAmount] = useState(0);
  const [lineWithHoldTaxAmount, setLineWithHoldTaxAmount] = useState("");
  const [linePayAmount, setLinePayAmount] = useState("");
  const [remarkSelected, setRemarkSelected] = useState(null);
  const [remarkCd, setRemarkCd] = useState("");
  const [note, setNote] = useState("");

  const [isHeadUpdated, setIsHeadUpdated] = useState(false);
  const [isLineUpdated, setIsLineUpdated] = useState(false);

  const [selectMenuOpen, setSelectMenuOpen] = useState(false);

  const _ref = useRef(null);

  //初期化
  useEffect(() => {
    const update = async () => {

      // 初期化
      setIndex(nvl(props.index));
      let line = props.line;
      setRoyDtlId(nvl(line.roy_dtl_id));
      setRoyId(nvl(line.roy_id));
      setAccCd(nvl(line.acc_cd));
      setLinePayRate(nvl(line.line_pay_rate));
      setLineAmount(nvl(amountFormatter(line.line_amount)));
      setLineAmountEx1(nvl(amountFormatter(line.line_amount_ex_1)));
      setLineTaxRate(nvl(amountFormatter(line.line_tax_rate)));
      setLineTaxAmount(nvl(amountFormatter(line.line_tax_amount)));
      setLineAmountEx2(nvl(amountFormatter(line.line_amount_ex_2)));
      setLineTotalAmount(nvl(amountFormatter(line.line_total_amount)));
      setLineWithHoldTaxAmount(nvl(amountFormatter(line.line_withhold_tax_amount)));
      setLinePayAmount(nvl(amountFormatter(line.line_pay_amount)));

      // 著者・口座情報
      if (line.author_cd) {
        const authorObj = await getAPI("ms_author/" + line.author_cd);
        if (authorObj) {
          setAuthorCdSelected({
            id: line.author_cd,
            name: nvl(line.author_cd) + " " + nvl(line.bank_account_nm),
            option: nvl(line.author_cd) + " " + rpad(nvl(authorObj.customer_nm), 20, ' ') + rpad(nvl(authorObj.penname_nm), 20, ' '),
            penname_nm: nvl(authorObj.penname_nm)
          });
          setAuthorCd(line.author_cd);

          const cBankCd = nvl(line.bank_cd);
          const cBankBranchCd = nvl(line.bank_branch_cd);
          const cKindOfAccountCl = nvl(line.kind_of_account_cl);
          const cBankAccountNo = nvl(line.bank_account_no);
          const cBankAccountNm = nvl(line.bank_account_nm);
          setBankCd(cBankCd);
          setBankBranchCd(cBankBranchCd);
          setKindOfAccountCl(cKindOfAccountCl);
          setBankAccountNo(cBankAccountNo);
          setBankAccountNm(cBankAccountNm);

          let cBankAccount = cBankAccountNm + "　";
          if (cBankCd && cBankBranchCd) {
            const oBank = await getAPI("ms_bank", {bank_cd: cBankCd, bank_branch_cd: cBankBranchCd});
            if (oBank.count === 1) {
              const o = oBank.results[0];
              cBankAccount += nvl(o.bank_nm) + "(" + nvl(o.bank_cd) + ")　";
              cBankAccount += nvl(o.bank_branch_nm) + "(" + nvl(o.bank_branch_cd) + ")　";
              if (cKindOfAccountCl === "0") {
                cBankAccount += "普通";
              } else if (cKindOfAccountCl === "1") {
                cBankAccount += "当座";
              } else if (cKindOfAccountCl === "9") {
                cBankAccount += "総合";
              }
              cBankAccount += "　" + cBankAccountNo;
            }
          }
          setBankAccount(cBankAccount);
        }
      }
      if (line.acc_cd) {
        setAccSelected([{id: line.acc_cd, name: lpad(nvl(line.acc_cd), 2, "0") + " " + nvl(line.Account_NM)}]);
        setAccCd(line.acc_cd);
      }

      // 支払区分
      if (line.pay_type_cd) {
        const payTypeRes = await getAPI("ms_code_typeahead_view", {code_type: "支払区分"});
        const matched = payTypeRes.results.find(obj => obj.value === line.pay_type_cd);
        if (matched) {
          setPayTypeCdSelected({id: matched.value, name: matched.value + " " + nvl(matched.code_name)});
        }
        setPayTypeCd(line.pay_type_cd);
      }

      // 摘要
      if (line.remark_cd) {
        setRemarkSelected({id: line.remark_cd, name: line.remark_cd});
        setRemarkCd(line.remark_cd);
      }
      setNote(nvl(line.note));
    }
    update();
  }, []);

  //呼出元への返却
  useImperativeHandle(ref, () => ({
    setSavedIds: (pRoyId, pRoyDtlId) => {
      setRoyId(nvl(pRoyId));
      setRoyDtlId(nvl(pRoyDtlId));
    },
    getStates: () => {
      // 数値項目の未入力は0、文字列項目の未入力はnull（明細が空の行は全てnullのまま）
      const hasData = !!(accCd || authorCd);
      const toNum = (val) => {
        const n = toNull(parseNumber(val));
        return n == null && hasData ? 0 : n;
      };
      return {
        index: toNull(index),
        roy_id: toNull(royId),
        roy_dtl_id: toNull(royDtlId),
        acc_cd: toNull(accCd),
        author_cd: toNull(authorCd),
        pay_type_cd: toNull(payTypeCd),
        bank_cd: toNull(bankCd),
        bank_branch_cd: toNull(bankBranchCd),
        kind_of_account_cl: toNull(kindOfAccountCl),
        bank_account_no: toNull(bankAccountNo),
        bank_account_nm: toNull(bankAccountNm),
        line_pay_rate: toNull(linePayRate),
        line_amount: toNum(lineAmount),
        line_amount_ex_1: toNum(lineAmountEx1),
        line_tax_rate: toNull(parseNumber(lineTaxRate)),
        line_tax_amount: toNum(lineTaxAmount),
        line_amount_ex_2: toNum(lineAmountEx2),
        line_total_amount: toNum(lineTotalAmount),
        line_withhold_tax_amount: toNum(lineWithHoldTaxAmount),
        line_pay_amount: toNum(linePayAmount),
        remark_cd: toNull(remarkCd),
        note: toNull(note),
        create_pg: 'RoyDtlLine',
        update_pg: 'RoyDtlLine'
      };
    },
    isEmpty: () => {
      if (accCd) {
        return false;
      }
      if (authorCd) {
        return false;
      }
      if (payTypeCd) {
        return false;
      }
      if (linePayRate) {
        return false;
      }
      if (lineAmount) {
        return false;
      }
      if (lineAmountEx1) {
        return false;
      }
      if (lineTaxRate) {
        return false;
      }
      if (lineTaxAmount) {
        return false;
      }
      if (lineAmountEx2) {
        return false;
      }
      if (lineTotalAmount) {
        return false;
      }
      if (lineWithHoldTaxAmount) {
        return false;
      }
      if (linePayAmount) {
        return false;
      }
      if (remarkCd) {
        return false;
      }
      if (note) {
        return false;
      }
      return true;
    }
  }), [
    index,
    royId,
    accCd,
    authorCd,
    royDtlId,
    payTypeCd,
    bankCd,
    bankBranchCd,
    kindOfAccountCl,
    bankAccountNo,
    bankAccountNm,
    linePayRate,
    lineAmount,
    lineAmountEx1,
    lineTaxRate,
    lineTaxAmount,
    lineAmountEx2,
    lineTotalAmount,
    lineWithHoldTaxAmount,
    linePayAmount,
    remarkCd,
    note
  ]);

  const onSearchPayTypeCd = async (query) => {
    let searchCondition = {
      code_type: "支払区分",
      search_value: query,
    }
    const res = await getAPI("ms_code_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: obj.value + " " + nvl(obj.code_name),
      id: obj.value
    }));
    return o;
    await onKeyDownNext();
  }

  const handleChangePayTypeCd = async (value) => {
    setPayTypeCdSelected(value);
    setPayTypeCd(value ? value.id : "");
    onKeyDownNext();
  }

  const onSearchRemark = async (query) => {
    if (!query) {
      return props.remarkList;
    }
    let searchCondition = {
      remark_nm: query
    }
    const res = await getAPI("ms_remark_typeahead_view", searchCondition);
    return res.results.map((obj) => ({
      name: nvl(obj.remark_cd) + " " + nvl(obj.remark_nm),
      id: obj.remark_cd,
      remark_nm: nvl(obj.remark_nm)
    }));
  }

  const handleKeyDownNote = (e) => {
    if (e.target.tagName === "TEXTAREA" && e.key === "Enter") {
      if (e.altKey) {
        e.preventDefault();
        const el = e.target;
        const start = el.selectionStart;
        const end = el.selectionEnd;
        const newVal = note.slice(0, start) + "\n" + note.slice(end);
        setNote(newVal);
        setTimeout(() => {
          el.selectionStart = el.selectionEnd = start + 1;
        }, 0);
      } else {
        onKeyDownNext(e);
      }
    }
  }

  const handleChangeRemark = async (value) => {
    if (!value) {
      setRemarkSelected(null);
      setRemarkCd("");
      return;
    }
    setRemarkSelected({
      id: value.id,
      name: value.id
    });
    setRemarkCd(value.id);
    setNote(value.remark_nm);
    onKeyDownNext();
  }

  const handleClearLine = () => {
    setAccSelected(null);
    setAccCd("");
    setAuthorCdSelected(null);
    setAuthorCd("");
    setPayTypeCdSelected(null);
    setPayTypeCd("");
    setBankCd("");
    setBankBranchCd("");
    setKindOfAccountCl("");
    setBankAccountNo("");
    setBankAccountNm("");
    setBankAccount("");
    setLinePayRate("");
    setLineAmount("");
    setLineAmountEx1("");
    setLineAmountEx2("");
    setLineTaxRate("");
    setLineTaxAmount("");
    setLineTotalAmount("");
    setLineWithHoldTaxAmount("");
    setLinePayAmount("");
    setRemarkSelected(null);
    setRemarkCd("");
    setNote("");
  }
  // 行計算 ///////////////////////////////////////////////////////////////////////////////

  // パーセント
  const onBlurLinePayRate = async (cLinePayRate) => {
    const cReceiveAmount = parseNumber(toSingleByte(String(props.receiveAmount)));
    if (!cReceiveAmount) {
      return false;
    }
    if (!cLinePayRate) {
      return false;
    }
    setLineAmount(amountFormatter(Math.floor(cReceiveAmount * cLinePayRate / 100)));
  }

  // 金額
  const onBlurLineAmount = async (cLineAmount) => {
    let cLineAmountNum = parseNumber(toSingleByte(String(cLineAmount)));
    if (cLineAmountNum === "" && !lineTotalAmount) {
      return; // 未入力のまま通過しただけなら処理終了
    }
    if (cLineAmountNum === "") {
      cLineAmountNum = 0; // 空は0として再計算
    }
    // 税率が空なら10をセット
    let cLineTaxRate = lineTaxRate ? parseNumber(String(lineTaxRate)) : 10;
    if (!lineTaxRate) {
      setLineTaxRate(10);
    }
    // 消費税（金額×税率 + 経費×税率）
    let cLineAmountEx1 = parseNumber(toSingleByte(String(lineAmountEx1))) || 0;
    let cLineAmountEx2 = parseNumber(toSingleByte(String(lineAmountEx2))) || 0;
    let cLineTaxAmount = Math.floor((cLineAmountNum + cLineAmountEx1) * cLineTaxRate / 100);
    let cLineTotalAmount = cLineAmountNum + cLineAmountEx1 + cLineTaxAmount + cLineAmountEx2;
    // 源泉を算出
    let cLineWithHoldTaxAmount = calcLineWithholdTaxAmount(cLineAmountNum + cLineAmountEx1 + cLineAmountEx2, null);
    // 支払金額（合計 - 源泉）
    let cLinePayAmount = cLineTotalAmount - cLineWithHoldTaxAmount;

    setLineAmount(amountFormatter(cLineAmountNum));
    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithHoldTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount));
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 経費
  const onBlurLineAmountEx1 = async (cLineAmountEx1) => {
    let cLineAmountEx1Num = parseNumber(toSingleByte(String(cLineAmountEx1))) || 0;
    let cLineAmountNum = parseNumber(toSingleByte(String(lineAmount))) || 0;
    let cLineAmountEx2Num = parseNumber(toSingleByte(String(lineAmountEx2))) || 0;
    // 税率が空なら10をセット
    let cLineTaxRate = lineTaxRate ? parseNumber(String(lineTaxRate)) : 10;
    if (!lineTaxRate) {
      setLineTaxRate(10);
    }
    // 消費税（金額×税率 + 経費×税率）
    let cLineTaxAmount = Math.floor((cLineAmountNum + cLineAmountEx1Num) * cLineTaxRate / 100);
    // 合計金額（金額 + 経費1 + 消費税 + 経費2）
    let cLineTotalAmount = cLineAmountNum + cLineAmountEx1Num + cLineTaxAmount + cLineAmountEx2Num;
    // 源泉を算出
    let cLineWithHoldTaxAmount = calcLineWithholdTaxAmount(cLineAmountNum + cLineAmountEx1Num + cLineAmountEx2Num, null);
    // 支払金額（合計 - 源泉）
    let cLinePayAmount = cLineTotalAmount - cLineWithHoldTaxAmount;

    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithHoldTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount));
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 税率
  const onBlurLineTaxRate = async (cLineTaxRate) => {
    let cLineTaxRateNum = parseNumber(toSingleByte(String(cLineTaxRate)));
    let cLineAmountNum = parseNumber(toSingleByte(String(lineAmount))) || 0;
    let cLineAmountEx1Num = parseNumber(toSingleByte(String(lineAmountEx1))) || 0;
    let cLineAmountEx2Num = parseNumber(toSingleByte(String(lineAmountEx2))) || 0;
    // 消費税（金額×税率 + 経費×税率）
    let cLineTaxAmount = Math.floor((cLineAmountNum + cLineAmountEx1Num) * cLineTaxRateNum / 100);
    // 合計金額（金額 + 経費1 + 消費税 + 経費2）
    let cLineTotalAmount = cLineAmountNum + cLineAmountEx1Num + cLineTaxAmount + cLineAmountEx2Num;
    // 源泉を算出
    let cLineWithHoldTaxAmount = calcLineWithholdTaxAmount(cLineAmountNum + cLineAmountEx1Num + cLineAmountEx2Num, null);
    // 支払金額（合計 - 源泉）
    let cLinePayAmount = cLineTotalAmount - cLineWithHoldTaxAmount;

    setLineTaxAmount(amountFormatter(cLineTaxAmount));
    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithHoldTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount));
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 消費税
  const onBlurLineTaxAmount = async (cLineTaxAmount) => {
    let cLineTaxAmountNum = parseNumber(toSingleByte(String(cLineTaxAmount))) || 0;
    let cLineAmountNum = parseNumber(toSingleByte(String(lineAmount))) || 0;
    let cLineAmountEx1Num = parseNumber(toSingleByte(String(lineAmountEx1))) || 0;
    let cLineAmountEx2Num = parseNumber(toSingleByte(String(lineAmountEx2))) || 0;
    // 合計金額（金額 + 経費1 + 消費税 + 経費2）
    let cLineTotalAmount = cLineAmountNum + cLineAmountEx1Num + cLineTaxAmountNum + cLineAmountEx2Num;
    // 源泉を算出
    let cLineWithHoldTaxAmount = calcLineWithholdTaxAmount(cLineAmountNum + cLineAmountEx1Num + cLineAmountEx2Num, null);
    // 支払金額（合計 - 源泉）
    let cLinePayAmount = cLineTotalAmount - cLineWithHoldTaxAmount;

    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithHoldTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount));
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 経費2
  const onBlurLineAmountEx2 = async (cLineAmountEx2) => {
    let cLineAmountEx2Num = parseNumber(toSingleByte(String(cLineAmountEx2))) || 0;
    let cLineAmountNum = parseNumber(toSingleByte(String(lineAmount))) || 0;
    let cLineAmountEx1Num = parseNumber(toSingleByte(String(lineAmountEx1))) || 0;
    let cLineTaxAmountNum = parseNumber(toSingleByte(String(lineTaxAmount))) || 0;
    // 合計金額（金額 + 経費1 + 消費税 + 経費2）
    let cLineTotalAmount = cLineAmountNum + cLineAmountEx1Num + cLineTaxAmountNum + cLineAmountEx2Num;
    // 源泉を算出
    let cLineWithHoldTaxAmount = calcLineWithholdTaxAmount(cLineAmountNum + cLineAmountEx1Num + cLineAmountEx2Num, null);
    // 支払金額（合計 - 源泉）
    let cLinePayAmount = cLineTotalAmount - cLineWithHoldTaxAmount;

    setLineTotalAmount(amountFormatter(cLineTotalAmount));
    setLineWithHoldTaxAmount(amountFormatter(cLineWithHoldTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount));
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 合計
  const onBlurLineTotalAmount = async (cLineTotalAmount) => {
    let cLineTotalAmountNum = parseNumber(toSingleByte(String(cLineTotalAmount))) || 0;
    let cLineAmountNum = parseNumber(toSingleByte(String(lineAmount))) || 0;
    let cLineAmountEx1Num = parseNumber(toSingleByte(String(lineAmountEx1))) || 0;
    let cLineAmountEx2Num = parseNumber(toSingleByte(String(lineAmountEx2))) || 0;
    // 源泉を算出
    let cLineWithHoldTaxAmount = calcLineWithholdTaxAmount(cLineAmountNum + cLineAmountEx1Num + cLineAmountEx2Num, null);
    // 支払金額（合計 - 源泉）
    let cLinePayAmount = cLineTotalAmountNum - cLineWithHoldTaxAmount;

    setLineWithHoldTaxAmount(amountFormatter(cLineWithHoldTaxAmount));
    setLinePayAmount(amountFormatter(cLinePayAmount));
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 源泉
  const onBlurLineWithHoldTaxAmount = async (cLineWithHoldTaxAmount) => {
    let cLineWithHoldTaxAmountNum = parseNumber(toSingleByte(String(cLineWithHoldTaxAmount))) || 0;
    let cLineTotalAmountNum = parseNumber(toSingleByte(String(lineTotalAmount))) || 0;
    // 支払金額（合計 - 源泉）
    let cLinePayAmount = cLineTotalAmountNum - cLineWithHoldTaxAmountNum;

    setLinePayAmount(amountFormatter(cLinePayAmount));
    setTimeout(() => {
      props.calcTotal();
    }, 0);
  }

  // 支払金額
  const onBlurLinePayAmount = async (cLineAmountEx1) => {
  }

  const onFocusCol = async (e) => {
    await sleepByPromise(0.02);
    onFocusText(e);
    props.appendLine();
  }

  const asyncSelectStyles = {
    option: (base, {data}) => ({
      ...base,
      whiteSpace: "pre-wrap",
      fontWeight: data.isHeader ? "bold" : base.fontWeight,
      color: data.isHeader ? "black" : base.color,
    }),
    singleValue: (base, {data}) => ({
      ...base,
      whiteSpace: "pre-wrap",
      fontWeight: data.isHeader ? "bold" : base.fontWeight,
      color: data.isHeader ? "black" : base.color,
    }),
  };

  const onSearchAcc = async (query) => {
    if (!query) {
      return props.accList;
    }
    let searchCondition = {
      search_value: query
    }
    const res = await getAPI("ms_acc1_typeahead_view", searchCondition);
    let o = res.results.map((obj) => ({
      name: lpad(nvl(obj.acc_cd), 3, "0") + " " + nvl(obj.acc_nm),
      id: obj.acc_cd
    }));
    return o;
  }

  const handleChangeAcc = async (value) => {
    setAccSelected(value);
    setAccCd(value ? value.id : "");
    if (!value) {
      handleClearLine();
      return;
    }

    setTimeout(() => {
      onKeyDownNext();
    }, 100); // バグ対応：遅延させることでカーソル表示
  }

  const onSearchAuthor = async (query) => {
    let searchCondition = {
      search_word: query,
      pay_grp_type: "原稿料"
    };
    let res = await getAPI("ms_author_search_view", searchCondition);
    let options = [{
      option: rpad("ID", 7, ' ') + rpad("名", 20, ' ') + rpad("ペンネーム", 20, ' ') + "住所",
      id: "",
      name: "",
      penname_nm: "",
      isHeader: true
    }];
    res.results.map((obj) => (
      options.push({
        option:
          nvl(obj.author_cd) + " " +
          rpad(nvl(obj.customer_nm), 20, ' ') +
          rpad(nvl(obj.penname_nm), 20, ' ') +
          (nvl(obj.author_address_1) + nvl(obj.author_address_2) + nvl(obj.author_address_3)).trim(),
        id: obj.author_cd,
        name: nvl(obj.author_cd) + " " + nvl(obj.customer_nm),
        penname_nm: nvl(obj.penname_nm)
      })));
    return options;
  }

  const handleChangeAuthor = async (value) => {
    setAuthorCdSelected(value);
    const cAuthorCd = value ? value.id : "";
    setAuthorCd(cAuthorCd);

    let cBankCd = "";
    let cBankBranchCd = "";
    let cKindOfAccountCl = "";
    let cBankAccountNo = "";
    let cBankAccountNm = "";
    let cBankAccount = "";
    if (cAuthorCd) {
      const obj = await getAPI("ms_author/" + cAuthorCd);
      if (obj) {
        cBankCd = nvl(obj.bank_cd);
        cBankBranchCd = nvl(obj.bank_branch_cd);
        cKindOfAccountCl = nvl(obj.kind_of_account_cl);
        cBankAccountNo = nvl(obj.bank_account_no);
        cBankAccountNm = nvl(obj.bank_account_nm);
        cBankAccount = cBankAccountNm + "　";
        const oBank = await getAPI("ms_bank", {bank_cd: cBankCd, bank_branch_cd: cBankBranchCd});
        if (oBank.count === 1) {
          const o = oBank.results[0];
          cBankAccount += nvl(o.bank_nm) + "(" + nvl(o.bank_cd) + ")　";
          cBankAccount += nvl(o.bank_branch_nm) + "(" + nvl(o.bank_branch_cd) + ")　";
          if (cKindOfAccountCl === "0") {
            cBankAccount += "普通";
          } else if (cKindOfAccountCl === "1") {
            cBankAccount += "当座";
          } else if (cKindOfAccountCl === "9") {
            cBankAccount += "総合";
          }
          cBankAccount += "　" + cBankAccountNo;
        }
      }
    }
    setBankCd(cBankCd);
    setBankBranchCd(cBankBranchCd);
    setKindOfAccountCl(cKindOfAccountCl);
    setBankAccountNo(cBankAccountNo);
    setBankAccountNm(cBankAccountNm);
    setBankAccount(cBankAccount);

    onKeyDownNext();
  }

  return (
    <div
      onKeyDownCapture={(e) => {
        // 矢印キーでセル移動（メニュー表示中は選択肢操作を優先）
        if (!selectMenuOpen && moveCellByArrow(e)) {
          e.stopPropagation();
        }
      }}
      onKeyDown={(e) => onKeyDownShortCut(e, null, props.onClickExpSave, props.onKeyDownEsc)}>

      <Row className="tbl-b-00">
        <Col lg={1} className="tbl-b-00-start"
             style={{borderBottom: "none", backgroundColor: "#e3e5e9", fontWeight: "bold", textAlign: "center", flex: "0 0 40px", maxWidth: "40px"}}>
          {index + 1}
        </Col>
        <Col lg={2} className="p-0 col-editable" style={{flex: "2 1 0%", maxWidth: "none"}}>
          <AsyncSelect
            tabIndex={100 * (index + 1) + 1001}
            className="async-select"
            classNamePrefix="async-select"
            components={{DropdownIndicator: null, ClearIndicator: null}}
            cacheOptions
            defaultOptions
            value={accSelected}
            onFocus={e => props.appendLine()}
            onMenuOpen={e => setSelectMenuOpen(true)}
            onMenuClose={e => setSelectMenuOpen(false)}
            onKeyDown={e => {
              if (!selectMenuOpen) {
                if (e.key === "ArrowDown") {
                  setSelectMenuOpen(true);
                  return;
                }
                setTimeout(() => {
                  onKeyDownNext(e);
                }, 100);
              }
            }}
            getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
            getOptionValue={e => e.id}
            loadOptions={e => onSearchAcc(e)}
            onChange={e => handleChangeAcc(e)}
            placeholder=""
            isClearable
          />
        </Col>
        <Col lg={3} className="p-0 col-editable" style={{flex: "3 1 0%", maxWidth: "none"}}>
          <AsyncSelect
            tabIndex={100 * (index + 1) + 1002}
            className="async-select async-select-author"
            classNamePrefix="async-select"
            styles={asyncSelectStyles}
            components={{DropdownIndicator: null, ClearIndicator: null}}
            cacheOptions
            isOptionDisabled={(option) => option.isHeader === true}
            value={authorCdSelected}
            onMenuOpen={e => setSelectMenuOpen(true)}
            onMenuClose={e => setSelectMenuOpen(false)}
            onKeyDown={e => {
              if (e.key === "Enter") {
                e.stopPropagation();
                if (!selectMenuOpen) {
                  setTimeout(() => {
                    onKeyDownNext(e);
                  }, 100);
                }
              } else if (!selectMenuOpen) {
                setTimeout(() => {
                  onKeyDownNext(e);
                }, 100);
              }
            }}
            getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.option}`}
            formatOptionLabel={(e, {context}) => {
              if (context === 'value') return Object.keys(e).length === 0 ? "" : e.name;
              return Object.keys(e).length === 0 ? "" : e.option;
            }}
            getOptionValue={e => e.id}
            loadOptions={onSearchAuthor}
            onChange={handleChangeAuthor}
            placeholder=""
            isClearable
          />
        </Col>
        <Col lg={5} className="p-0" style={{flex: "5 1 0%", maxWidth: "none"}}>
          <Form.Control plaintext readOnly tabIndex={-1} value={bankAccount} style={{paddingLeft: "15px"}}/>
        </Col>
      </Row>
      <Row className="tbl-b-00">
        <Col lg={1} className="tbl-b-00-start"
             style={{
               borderTopColor: "#e3e5e9",
               borderBottom: "none",
               backgroundColor: "#e3e5e9",
               fontWeight: "bold",
               flex: "0 0 40px",
               maxWidth: "40px"
             }}>
        </Col>
        <Col lg={1} className="p-0 col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <AsyncSelect
            key={payTypeCdSelected?.id || 'default'}
            tabIndex={100 * (index + 1) + 1012}
            className="async-select"
            classNamePrefix="async-select"
            components={{DropdownIndicator: null, ClearIndicator: null}}
            cacheOptions
            defaultOptions
            value={payTypeCdSelected}
            onFocus={e => props.appendLine()}
            onMenuOpen={e => setSelectMenuOpen(true)}
            onMenuClose={e => setSelectMenuOpen(false)}
            onKeyDown={e => {
              if (!selectMenuOpen) {
                if (e.key === "ArrowDown") {
                  setSelectMenuOpen(true);
                  return;
                }
                setTimeout(() => {
                  onKeyDownNext(e);
                }, 100); // バグ対応：遅延させることでカーソル表示
              }
            }}
            getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
            getOptionValue={e => e.id}
            loadOptions={e => onSearchPayTypeCd(e)}
            onChange={handleChangePayTypeCd}
            placeholder=""
            isClearable
          />
        </Col>
        <Col lg={1} className="p-0 input-group col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1013}
            name="linePayRate"
            type="text"
            inputMode="decimal"
            style={{textAlign: "right"}}
            value={linePayRate}
            onKeyPress={e => {
              checkKey(e, /[0-9\.]/);
              onKeyDownNext(e);
            }}
            onFocus={e => onFocusCol(e)}
            onChange={e => setLinePayRate(e.target.value)}
            onBlur={e => onBlurLinePayRate(e.target.value)}
          />
        </Col>
        <Col lg={1} className="p-0 input-group col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1014}
            name="lineAmount"
            type="text"
            inputMode="numeric"
            style={{textAlign: "right"}}
            value={amountFormatter(lineAmount)}
            onKeyPress={e => {
              checkKey(e, /[0-9\-]/);
              onKeyDownNext(e);
            }}
            onFocus={e => onFocusCol(e)}
            onChange={e => setLineAmount(e.target.value)}
            onBlur={e => onBlurLineAmount(e.target.value)}
          />
        </Col>
        <Col lg={1} className="p-0 input-group col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1015}
            name="lineAmountEx1"
            type="text"
            inputMode="numeric"
            style={{textAlign: "right"}}
            value={amountFormatter(lineAmountEx1)}
            onKeyPress={e => {
              checkKey(e, /[0-9\-]/);
              onKeyDownNext(e);
            }}
            onFocus={e => onFocusCol(e)}
            onChange={e => setLineAmountEx1(e.target.value)}
            onBlur={e => onBlurLineAmountEx1(e.target.value)}
          />
        </Col>
        <Col lg={1} className="p-0 input-group col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1016}
            name="lineTaxRate"
            type="text"
            inputMode="numeric"
            style={{textAlign: "right"}}
            value={amountFormatter(lineTaxRate)}
            onKeyPress={e => {
              checkKey(e, /[0-9\-]/);
              onKeyDownNext(e);
            }}
            onFocus={e => onFocusCol(e)}
            onChange={e => setLineTaxRate(e.target.value)}
            onBlur={e => onBlurLineTaxRate(e.target.value)}
          />
        </Col>
        <Col lg={1} className="p-0 input-group col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1017}
            name="lineTaxAmount"
            type="text"
            inputMode="numeric"
            style={{textAlign: "right"}}
            value={amountFormatter(lineTaxAmount)}
            onKeyPress={e => {
              checkKey(e, /[0-9\-]/);
              onKeyDownNext(e);
            }}
            onFocus={e => onFocusCol(e)}
            onChange={e => setLineTaxAmount(e.target.value)}
            onBlur={e => onBlurLineTaxAmount(e.target.value)}
          />
        </Col>
        <Col lg={1} className="p-0 input-group col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1018}
            name="lineAmountEx2"
            type="text"
            inputMode="numeric"
            style={{textAlign: "right"}}
            value={amountFormatter(lineAmountEx2)}
            onKeyPress={e => {
              checkKey(e, /[0-9\-]/);
              onKeyDownNext(e);
            }}
            onFocus={e => onFocusCol(e)}
            onChange={e => setLineAmountEx2(e.target.value)}
            onBlur={e => onBlurLineAmountEx2(e.target.value)}
          />
        </Col>
        <Col lg={1} className="p-0 input-group col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1019}
            name="lineTotalAmount"
            type="text"
            inputMode="numeric"
            style={{textAlign: "right"}}
            value={amountFormatter(lineTotalAmount)}
            onKeyPress={e => {
              checkKey(e, /[0-9\-]/);
              onKeyDownNext(e);
            }}
            onFocus={e => onFocusCol(e)}
            onChange={e => setLineTotalAmount(e.target.value)}
            onBlur={e => onBlurLineTotalAmount(e.target.value)}
          />
        </Col>
        <Col lg={1} className="p-0 input-group col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1020}
            name="lineWithHoldTaxAmount"
            type="text"
            inputMode="numeric"
            style={{textAlign: "right"}}
            value={amountFormatter(lineWithHoldTaxAmount)}
            onKeyPress={e => {
              checkKey(e, /[0-9\-]/);
              onKeyDownNext(e);
            }}
            onFocus={e => onFocusCol(e)}
            onChange={e => setLineWithHoldTaxAmount(e.target.value)}
            onBlur={e => onBlurLineWithHoldTaxAmount(e.target.value)}
          />
        </Col>
        <Col lg={2} className="p-0 input-group col-editable" style={{flex: "1 1 0%", maxWidth: "none"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1021}
            name="linePayAmount"
            type="text"
            inputMode="numeric"
            style={{textAlign: "right"}}
            value={amountFormatter(linePayAmount)}
            onKeyPress={e => {
              checkKey(e, /[0-9\-]/);
              onKeyDownNext(e);
            }}
            onFocus={e => onFocusCol(e)}
            onChange={e => setLinePayAmount(e.target.value)}
            onBlur={e => onBlurLinePayAmount(e.target.value)}
          />
        </Col>
      </Row>
      <Row className="tbl-b-00" style={{flexWrap: "nowrap"}}>
        <Col lg={1} className="tbl-b-00-start"
             style={{
               borderTopColor: "#e3e5e9",
               borderBottom: "solid 1px #AAAAAA",
               backgroundColor: "#e3e5e9",
               fontWeight: "bold",
               flex: "0 0 40px",
               maxWidth: "40px"
             }}>
        </Col>
        <Col lg={1} className="col-editable col-remark" style={{padding: "0", flex: "0 0 120px", maxWidth: "120px", borderBottom: "solid 1px #AAAAAA"}}>
          <AsyncSelect
            tabIndex={100 * (index + 1) + 1022}
            name="remarkCd"
            className="async-select"
            classNamePrefix="async-select"
            components={{DropdownIndicator: null, ClearIndicator: null}}
            cacheOptions
            defaultOptions
            value={remarkSelected}
            onFocus={e => onFocusCol(e)}
            onMenuOpen={e => setSelectMenuOpen(true)}
            onMenuClose={e => setSelectMenuOpen(false)}
            onKeyDown={e => {
              if (!selectMenuOpen) {
                if (e.key === "ArrowDown") {
                  setSelectMenuOpen(true);
                  return;
                }
                if (e.key === "Delete") {
                  handleChangeRemark(null);
                  return;
                }
                setTimeout(() => {
                  onKeyDownNext(e);
                }, 100);
              }
            }}
            getOptionLabel={e => Object.keys(e).length === 0 ? "" : `${e.name}`}
            getOptionValue={e => e.id}
            loadOptions={e => onSearchRemark(e)}
            onChange={handleChangeRemark}
            placeholder=""
            isClearable
          />
        </Col>
        <Col className="input-group col-editable" style={{padding: "0", flex: "1 1 auto", maxWidth: "none", borderBottom: "solid 1px #AAAAAA", borderRight: "solid 1px #ced4da"}}>
          <Form.Control
            tabIndex={100 * (index + 1) + 1023}
            as="textarea"
            rows={1}
            style={{fieldSizing: "content", overflow: "hidden", resize: "none", border: "1px solid transparent", backgroundColor: "transparent", padding: "8px"}}
            value={note}
            onKeyDown={e => handleKeyDownNote(e)}
            onFocus={e => onFocusText(e)}
            onChange={e => setNote(e.target.value)}
          />
        </Col>
      </Row>
    </div>
  );
});

export default React.memo(RoyDtlLine);
